import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";

@inject(HttpClient)
export class AccountYTManagerAPI {
  constructor(http) {
    this.http = http;
  }


  ytManagerSave(userData, accountData,paymentToken, logo_file, token, successCallback, errorCallback) {
    let formData = new FormData();
    formData.append('user', JSON.stringify(userData));
    formData.append('account', JSON.stringify(accountData));
    formData.append('token', paymentToken);

    if (logo_file != null) {
      formData.append('logo_file', logo_file);
    }

    let http = new HttpClient().configure(x => {
      x.withHeader('Authorization', token);
    });

    http.post('api/youtubeManager/account/save', formData)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('userdata')) {
            successCallback(json.userdata);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }
  getUserList(search, whitelabel_id, page, limit, sortBy, sortDir, token, successCallback, errorCallback, isVendasta = 0) {

    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
        .withHeader('Authorization', token);
    });

    let queryString = `?page=${page}&limit=${limit}&sortBy=${sortBy}&sortDir=${sortDir}&isVendasta=${isVendasta}`;

    if (search)
      queryString += "&search=" + search;

    if (whitelabel_id)
      queryString += "&whitelabel_id=" + whitelabel_id;

    this.http.get('api/youtubeManager/account/getUserList' + queryString)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('users')) {
            successCallback(json.users);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  getAccountStatusList(token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
        .withHeader('Authorization', token);
    });

    this.http.get('api/youtubeManager/account/getAccountStatusList')
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('accountStatusList')) {
            successCallback(json.accountStatusList);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }
  getBusinessTypeList(successCallback, errorCallback) {

    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json');

    });


    this.http.get('api/account/getBusinessTypeList')
      .then(data => {

        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("businessTypeList"))
            successCallback(json.businessTypeList);

          if (json.hasOwnProperty("error"))
            errorCallback(json.error);

        }
        else {
          errorCallback(data.statusText);
        }
      });

  }

  getUserData(id, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
        .withHeader('Authorization', token);
    });

    this.http.get('api/youtubeManager/account/getUserData/' + id)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('userdata')) {
            successCallback(json.userdata);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  saveCustomOpener(id, file, token, successCallback, errorCallback, vertical = false) {

    var formData = new FormData();
    if (file != null)
      formData.append('opener', file);

    var http = new HttpClient().configure(x => {
      x.withHeader("Authorization", token);
    });

    http.post('api/youtubeManager/account/saveCustomOpener/' + id + (vertical ? "?vertical=true" : ""), formData)
      .then(data => {

        if (data.isSuccess) {
          successCallback();
        } 
        else {
          errorCallback(data.statusText);
        }
      });

  }

  hasCustomOpener(id, query, token, successCallback, errorCallback) {


    var http = new HttpClient().configure(x => {
      x.withHeader("Authorization", token);
    });

    http.get('api/youtubeManager/account/hasCustomOpener/' + id +'?'+ new URLSearchParams(query).toString())
      .then(data => {

        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("result"))
            successCallback(json.result);
          else
            successCallback(false);
        }
        else {
          errorCallback(data.statusText);
        }
      });

  }  



}
